import { type CTNDropdownOptionProps } from '@ctn/ui/types/ctn-dropdown';

import { Priordades } from '@/interfaces/model/emisor.interface';

export const dropdownPriorityOptions: CTNDropdownOptionProps[] = [
	{ value: 1, label: Priordades.Alta, icon: 'status', iconColor: 'red-50'  },  
	{ value: 2, label: Priordades.Media, icon: 'status', iconColor: 'orange-50' },  
	{ value: 3, label: Priordades.Baja, icon: 'status', iconColor: 'blue-50'  } 
];